export default function IconWarning({ className }: { className?: string }) {
  return (
    <svg
      width='17'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle cx='8' cy='8' r='8' fill='#D71919' />
      <path
        d='M8.6804 3.27273L8.53977 9.43466H7.16761L7.03125 3.27273H8.6804ZM7.85369 12.0938C7.59517 12.0938 7.37358 12.0028 7.18892 11.821C7.0071 11.6392 6.91619 11.4176 6.91619 11.1562C6.91619 10.9006 7.0071 10.6818 7.18892 10.5C7.37358 10.3182 7.59517 10.2273 7.85369 10.2273C8.10653 10.2273 8.32528 10.3182 8.50994 10.5C8.69744 10.6818 8.79119 10.9006 8.79119 11.1562C8.79119 11.3295 8.74716 11.4872 8.65909 11.6293C8.57386 11.7713 8.46023 11.8849 8.31818 11.9702C8.17898 12.0526 8.02415 12.0938 7.85369 12.0938Z'
        fill='white'
      />
    </svg>
  )
}
